import styled from "styled-components";

export const Container = styled.div``;

export const DetailsContainer = styled.div`
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const DetailRow = styled.span`
  font-size: 16px;
  color: var(--dark-gray);
  
  strong {
    color: var(--primary);
    font-weight: 600;
  }
`;

export const CancelText = styled.span`
  color: var(--error);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`;
